// react, react-redux, redux-form
import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";

// helpers
import { required, number, greaterThanZero } from "../../../helpers/validate";
import { fileUploaded } from "../../../helpers/actionsHelpers";
import {
  formatCurrency,
  normalizeCurrency,
  jumpToError,
} from "../../../helpers/renderHelpers";

// redux actions
import { saveAppState } from "../../../actions/appActions";

// enums
import {
  WORK_CATEGORY_LIST,
  ACTIVITIES_ESTIMATE_LIST,
} from "../../../config/enums";

// render components
import RenderField from "../../global/RenderField";

const proposedWorks = (props) => {
  const {
    formData,
    formName,
    attachments,
    handleSubmit,
    previousPage,
    saveAppState,
    appState,
    isAppSaving,
  } = props;

  let disabledTags;

  if (formData && formData.workCategories) {
    for (var i = 0; i < formData.workCategories.length; i++) {
      if (
        formData.workCategories[i].category === WORK_CATEGORY_LIST[0].category
      ) {
        disabledTags = WORK_CATEGORY_LIST[1];
      } else if (
        formData.workCategories[i].category === WORK_CATEGORY_LIST[1].category
      ) {
        disabledTags = WORK_CATEGORY_LIST[0];
      }
    }
  }

  return (
    <form id={formName} onSubmit={handleSubmit}>
      <div className="sq-form-section">
        <div className="sq-form-section-description">
          <h2>Proposed works</h2>
        </div>
        <div className="sq-form-section">
          <Field
            name="feeQuestionnaireQuestions"
            type="checkbox"
            label="Type of permit(s)"
            component={RenderField}
            templateList={[
              {
                name:
                  "To subdivide, consolidate or realign a boundary of a registered place",
                value: "HVQ001",
              },
              {
                name: "For works or activities to a registered place or object",
                value: "HVQ002",
              },
              {
                name:
                  "To demolish or destroy the whole of a registered place or object",
                value: "HVQ003",
              },
            ]}
            onChange={(e) => {
              props.change(`feePayable`, "");
              appState.service.quoteResponse = {};
              if (props.formData.feeQuestionnaire) {
                let categoryExists = props.formData.feeQuestionnaire.filter(
                  (item) => {
                    return item.qid === e.forEach((question) => question);
                  }
                );
                if (e.length < formData.feeQuestionnaire.length) {
                  props.array.remove(
                    "feeQuestionnaire",
                    formData.feeQuestionnaire
                      .map((item) => {
                        return e.findIndex((value) => value === item.qid);
                      })
                      .findIndex((item) => item === -1)
                  );
                } else if (categoryExists.length === 0) {
                  props.change(
                    `feeQuestionnaire["${e.length - 1}"].qid`,
                    e[e.length - 1]
                  );
                  props.change(
                    `feeQuestionnaire["${e.length - 1}"].answer`,
                    "true"
                  );
                } else if (e.length > 0) {
                  props.change(
                    `feeQuestionnaire["${e.length - 1}"].qid`,
                    e[e.length]
                  );
                  props.change(
                    `feeQuestionnaire["${e.length - 1}"].answer`,
                    "true"
                  );
                }
              } else {
                props.change(`feeQuestionnaire[0].qid`, e[0]);
                props.change(`feeQuestionnaire[0].answer`, "true");
              }
            }}
            validate={required}
            required
          />
          {formData.feeQuestionnaire &&
            formData.feeQuestionnaire &&
            formData.feeQuestionnaire.find(
              (question) => question.qid === "HVQ002"
            ) && (
              <Field
                name={`feeQuestionnaire[${formData.feeQuestionnaire.findIndex(
                  (question) => {
                    return question.qid === "HVQ002";
                  }
                )}].answer`}
                type="radiobox"
                component={RenderField}
                label="The works or activities estimated cost is"
                templateList={ACTIVITIES_ESTIMATE_LIST}
                onChange={() => {
                  props.change(`feePayable`, "");
                  appState.service.quoteResponse = {};
                }}
                validate={required}
                required
              />
            )}
        </div>
        <Field
          name="workCategories"
          type="selectMultiple"
          component={RenderField}
          data={WORK_CATEGORY_LIST}
          disabledData={[disabledTags]}
          valueField="id"
          textField="category"
          label="Work Categories"
          placeholder="Add related work categories"
          validate={required}
          note="Please identify the category (or categories) your proposed works belong to."
          required
          busy
        />
        <Field
          name="detailedDescriptionOfProposedWorks"
          type="textarea"
          maxlength="1000"
          component={RenderField}
          label="Detailed description"
          note="Provide a detailed description of the proposed works."
          validate={required}
          required
        />
        <Field
          name="reasonAndPurposeOfProposedWorks"
          type="textarea"
          maxlength="1000"
          component={RenderField}
          label="Reason & purpose"
          note="State the reason and purpose for which the proposed works are required."
          validate={required}
          required
        />
        <Field
          name="impactOfProposedWorks"
          type="textarea"
          maxlength="1000"
          component={RenderField}
          label="Impact on heritage"
          note="State the impact of your proposed works and why the impact will not harm the heritage values of the place or object."
          validate={required}
          required
        />
        <Field
          name="worksOnCrownLandFlag"
          type="radiobox"
          label="Are the proposed works entirely on Crown Land?"
          component={RenderField}
          validate={required}
          required
          templateList={[
            { name: "Yes", value: "true" },
            { name: "No", value: "false" },
          ]}
        />
        {formData.worksOnCrownLandFlag === "false" && (
          <div className="sq-form-section-description">
            <ul className="list">
              <li className="list-tile info">
                <div className="list-tile-content">
                  <p>
                    You will be required to upload the relevant land title(s)
                    issued within 30 days, along with all other supporting
                    documentation at the end of this form.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        )}
        <Field
          name="estimatedCostOfWorks"
          type="text"
          component={RenderField}
          label="Estimated cost of the works ($)"
          note="The cost of works should be more than “$0”"
          validate={[required, number, greaterThanZero]}
          format={formatCurrency}
          normalize={normalizeCurrency}
          required
        />
        {formData.estimatedCostOfWorks && (
          <div className="sq-form-section-description">
            <ul className="list">
              <li className="list-tile info">
                <div className="list-tile-content">
                  <p>
                    You will be required to upload the supporting document(s)
                    later in this form with a quote or cost breakdown to verify
                    the figure entered above.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        )}
      </div>
      <div className="sq-form-control">
        <button
          type="button"
          className="sq-form-page-button previous"
          onClick={previousPage}
        >
          Previous
        </button>
        <button
          type="submit"
          className="sq-form-page-button next"
          onClick={jumpToError}
        >
          Next
        </button>
      </div>
      <div className="sq-form-control">
        <button
          type="button"
          className="sq-form-page-button"
          onClick={() => saveAppState(appState, formName)}
          disabled={isAppSaving || fileUploaded(attachments)}
        >
          Save and Exit
        </button>
        <p className="sq-form-page-button-note">
          An email will be sent to Primary contact email address
        </p>
      </div>
    </form>
  );
};

const mapStateToProps = (state, formName) => {
  return {
    formData: state.form[formName.form] ? state.form[formName.form].values : {},
    attachments: state.service.attachments,
    isAppSaving: state.app.isAppSaving,
    appState: state,
  };
};

const mapDispatchToProps = {
  saveAppState,
};

const form = reduxForm({
  destroyOnUnmount: false, //        <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(form(proposedWorks));
